/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { gql } from '@apollo/client';

export const ASSET_FRAGMENT = gql`
  fragment AssetAllFields on Asset {
    id
    title
    tags
    cost
    categories
    thumbnail {
      id
      url
      tags
    }
    attachments {
      id
      tags
      label
      ... on PreviewAttachment {
        url
        kind
      }
      ... on DownloadAttachment {
        url
        filename
        mimetype
        size
        revisions {
          filename
          mimetype
          size
          revision
        }
      }
    }
    extraData {
      key
      value
    }
    createdAt
    updatedAt
    status
    __typename
  }
`;

export const QUERY_ASSET = gql`
  query Asset($id: String!) {
    asset(id: $id) {
      ...AssetAllFields
    }
  }

  ${ASSET_FRAGMENT}
`;

export const QUERY_ASSETS = gql`
  query Assets(
    $page: Int
    $limit: Int = 20
    $search: String
    $filters: AssetFilters
    $sortDir: SortDir = desc
    $sort: AssetSort = byCreationDate
  ) {
    assets(
      search: $search
      filters: $filters
      sort: $sort
      sortDir: $sortDir
      page: $page
      limit: $limit
    ) {
      total
      hasMore
      items {
        ...AssetAllFields
      }
    }
  }

  ${ASSET_FRAGMENT}
`;

export const QUERY_ASSETS_MANY = gql`
  query Assets(
    $page: Int
    $limit: Int = 20
    $search: String
    $filters: AssetFilters
    $sortDir: SortDir = desc
    $sort: AssetSort = byCreationDate
  ) {
    assets(
      search: $search
      filters: $filters
      sort: $sort
      sortDir: $sortDir
      page: $page
      limit: $limit
    ) {
      total
      hasMore
      items {
        ...AssetAllFields
      }
    }
  }

  ${ASSET_FRAGMENT}
`;

export const CREATE_ASSET = gql`
  mutation CreateTypedAsset($fileId: String!, $type: AssetTypename!) {
    createTypedAsset(fileId: $fileId, type: $type) {
      ...AssetAllFields
    }
  }

  ${ASSET_FRAGMENT}
`;

export const UPDATE_ASSET = gql`
  mutation UpdateAsset($id: String!, $asset: AssetUpdate!) {
    updateAsset(update: $asset, id: $id) {
      ...AssetAllFields
    }
  }

  ${ASSET_FRAGMENT}
`;

export const DELETE_ASSET = gql`
  mutation DeleteAsset($id: String!) {
    deleteAsset(id: $id)
  }
`;
